import React from "react";
import { cn } from "../../utils/cn";
import { viewOptions } from "../../utils/constants";
import { LucideIcon } from "lucide-react";

interface MobileNavProps {
    activeView: string;
    setActiveView: (view: string) => void;
    isMobile: boolean;
    canAccessPage: (page: string) => boolean;
}

export function MobileNav({ activeView, setActiveView, isMobile, canAccessPage }: MobileNavProps) {
    if (!isMobile) return null;

    return (
        <nav className="fixed bottom-0 left-0 right-0 h-[64px] bg-white dark:bg-siemens-elevation-base-1 border-t border-siemens-deep-blue/8 dark:border-siemens-divider flex items-center justify-between px-1 pb-safe-bottom z-50">
            {viewOptions.filter(view => canAccessPage(view.id)).map(view => {
                const Icon = view.icon as LucideIcon;
                const isActive = activeView === view.id;
                return (
                    <button
                        key={view.id}
                        onClick={() => setActiveView(view.id)}
                        className={cn(
                            "flex-1 flex flex-col items-center justify-center py-1 rounded-lg transition-all min-w-0",
                            isActive
                                ? "text-siemens-petrol dark:text-siemens-petrol-light"
                                : "text-siemens-text-light-soft dark:text-siemens-text-soft hover:bg-siemens-deep-blue/5 dark:hover:bg-white/5"
                        )}
                    >
                        <span className={cn(
                            "w-8 h-8 flex items-center justify-center mb-0.5 rounded-full transition-all",
                            isActive ? "bg-siemens-petrol text-white shadow-md transform scale-105" : "bg-transparent"
                        )}>
                            <Icon className="w-5 h-5" />
                        </span>
                        <span className={cn(
                            "text-[10px] capitalize whitespace-nowrap",
                            isActive ? "font-bold" : "font-medium"
                        )}>{view.id}</span>
                    </button>
                );
            })}
        </nav>
    );
}

export default MobileNav;
